var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26316 16.8421C6.15859 16.8421 5.26316 15.9467 5.26316 14.8421V2C5.26316 0.895431 6.15859 0 7.26316 0H18C19.1046 0 20 0.89543 20 2V14.8421C20 15.9467 19.1046 16.8421 18 16.8421H7.26316ZM0 7.36842H3.15789V3.15789H0V7.36842ZM0 13.6842H3.15789V9.47368H0V13.6842ZM16.8421 3.15789H8.42105V6.31579H16.8421V3.15789ZM12.6316 8.42105H13.6842V10.5263H12.6316V8.42105ZM12.6316 11.5789H10.5263V10.5263H12.6316V11.5789ZM13.6842 11.5789V13.6842H12.6316V11.5789H13.6842ZM13.6842 11.5789H15.7895V10.5263H13.6842V11.5789Z",
    fill: "#7C90B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.e2eb0ea7.svg";
export { ForwardRef as ReactComponent };